import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import SignUpIcon from '../../assets/image/signupIcon.png'
import MessageIcon from '../../assets/image/messageIcon.png'
import { V2_BUTTON_COLOR } from '../../config/color';

const SLink = styled(Link)``;
const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  @media (max-width: 768px) {
    height: 100%;
  }

  div {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    p {
      width: 180px;
      margin-bottom: 30px;
      @media (max-width: 768px) {
        width: 100px;
      }

      img {
        width: 100%;
      }
    }
    h2 {
      font-size: 30px;
      margin-bottom: 30px;
      @media (max-width: 768px) {
        font-size: 20px;
        margin-bottom: 10px;
      }
    }
    div {
      margin-bottom: 30px;

      &:is(:last-child) {
        margin-top: 40px;
        padding-top: 20px;
        width: 330px;
        border-top: 2px solid rgba(116, 119, 126, 0.3);
        @media (max-width: 768px) {
          margin-top: 20px;
          border-top: 1px solid rgba(116, 119, 126, 0.3);
          width: 100%;
        }

        p {
          &:is(:first-child) {
            font-weight: 600;
          }
          width: 100%;
          color: #74777E;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          margin-bottom: 0px;
          line-height: 22px;
        }
      }

      h3 {
        color: #74777E;
        line-height: 24px;
        @media (max-width: 768px) {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }

    ${SLink} {
      background-color: ${V2_BUTTON_COLOR};
      border-radius: 16px;
      padding: 16px 24px;
      color: white;
      font-size: 18px;
    }
  }
`

export const Notice = (data) => {
  const {active} = data;
  return (
    <Container>
      <div>
        <p>
          <img src={active ? SignUpIcon : MessageIcon}/>
        </p>
        {active ? (
          <h2>
            파트너 회원가입이 완료 되었습니다.
          </h2>
        ) : (
          <>
            <h2>
              이용에 불편을 드려죄송합니다.
            </h2>
            <h2>
              현재 준비중인 서비스입니다.
            </h2>
          </>
        )}
        {active ? (
          <div>
            <h3>
              잠시만 기다려주세요. 입점 신청서를 확인 후, 이메일로 알려드립니다.
            </h3>
            <h3>
              로그인 후 트레져러의 다양한 서비스를 이용할 수 있습니다.
            </h3>
            <h3>
              2일 정도 소요될 수 있습니다.
            </h3>
          </div>
        ) : (
          <div>
            <h3>
              트레져러는 매일 매일 조금씩 자라나고 있습니다.
            </h3>
            <h3 style={{color: `${V2_BUTTON_COLOR}`}}>
              * 해당 서비스는 3월 중으로 오픈 예정입니다.
            </h3>
          </div>
        )}
        {active ? (
          <SLink to="/signin">
            로그인
          </SLink>
        ) : null}
        <div>
          <p>(주) 얼마야</p>
          <p>사업자 등록번호 527 - 81 - 01503   |   대표 : 김경태</p>
          <p>06133 서울 강남구 테헤란로 129 7층</p>
          <p>개인정보 처리방침   |  서비스 이용약관</p>
        </div>
      </div>
    </Container>
  )
}